/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Represents an ordered list of "option" values which can be objects with `id`
 * and `name` properties or primitives (in which case primitives are toString'd
 * to produce id and name)
 */

class OptionList {
  _list: Array<any>;
  _byID: {
    [key: string]: any;
  };
  length: number;

  constructor(items: Array<any>) {
    let list: Array<any> = (this._list = []);
    let byID: ObjectOf<any> = (this._byID = {});
    items.forEach((item) => {
      let value = OptionList.toValue(item);
      if (item != null) {
        list.push((byID[value.id] = value));
      }
    });
    this.length = list.length;
  }

  getByID(id: string) {
    return this._byID[id];
  }

  getByIndex(i: number) {
    return this._list[i];
  }

  map<T, U>(
    fn: (value: T, index: number, array: Array<T>) => U,
    context?: any,
  ): Array<U> {
    if (context == null) {
      return this._list.map(fn);
    } else {
      return this._list.map(fn, context);
    }
  }

  valueExists(item: any) {
    let value = OptionList.toValue(item);
    return value == null ? false : !!this._byID[value.id];
  }

  static toValue(item: any) {
    if (item == null) {
      return item;
    }
    if (Object(item) === item) {
      return {
        id: String(item.id),
        name: item.name,
        original: item,
      };
    } else {
      let str = String(item);
      return {
        id: str,
        name: str,
        original: item,
      };
    }
  }
}

export default OptionList;
